export const TimezonesEnum = {
    DENMARK: 'dk',
    SWEDEN: 'se',
    ENGLAND: 'gb',
    NORWAY: 'no',
}
